export default __webpack_public_path__ + "static/media/renuma-plus-07.19dbdc7d.png";